<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>Da li ste sigurni da želite da obrišete transakciju?</p>
    </div>
    <hr />
    <div class="footer">
      <button
        type="submit"
        class="btn btn-default btn--mod close-btn"
        @click="closeModal"
      >
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-danger btn--mod"
        @click="deleteTransaction"
        :disabled="loading"
      >
        <p v-if="!loading">Potvrdi</p>
        <spinner :size="20" line-fg-color="#610d0d" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import { financesInstance } from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState('modal', ['transaction']),
    ...mapState('finances', ['transactions'])
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapMutations('table', ['setTableData']),
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapActions('finances', ['getTableData']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    deleteTransaction() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      if (this.transaction.member_id) {
        financesInstance
          .delete(
            `members/${this.transaction.member_id}/transactions/${
              this.transaction.tid
            }`
          )
          .then(async () => {
            await this.getTableData({
              communityId: this.$store.getters.getActiveCommunity.id,
              tableName: 'transactions'
            });
            this.setTableData(this.transactions.data);
            this.closeModal();
            this.showSuccessModal();
          })
          .catch(() => {
            this.showErrorModal();
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        financesInstance
          .delete(
            `communities/${this.$store.getters.getActiveCommunity.id}
/transactions/${this.transaction.tid}`
          )
          .then(async () => {
            await this.getTableData({
              communityId: this.$store.getters.getActiveCommunity.id,
              tableName: 'transactions'
            });
            this.setTableData(this.transactions.data);
            this.closeModal();
            this.showSuccessModal();
          })
          .catch(() => {
            this.showFailModal();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>

<style scoped>
.close-btn {
  margin-right: 4px;
}

.btn--mod {
  height: 35px;
  min-width: 75px;
  margin-left: 5px;
  align-self: center;
}
</style>
